// ============================================================
// 챗봇 운영 설정의 중국어(zh) 값 mock 저장소 (localStorage).
// API 연동 코드는 이미 반영됨(*_zh 필드 송수신) — 이 파일은 백엔드 배포 전
// 과도기용 폴백이며, 배포 확인 후 이 파일과 각 사용처의 mock 폴백을 삭제한다.
// 연동 명세: docs/frontend-zh-content-handoff.md
// ============================================================
const STORAGE_KEY = "mock_zh_chatbot_settings";

const DEFAULTS = {
    welcome_title_zh: "",
    welcome_message_zh: "",
    // { [categoryId]: { name_zh, description_zh } }
    categories: {},
};

export function loadZhSettings() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return { ...DEFAULTS };
        const parsed = JSON.parse(raw);
        return {
            welcome_title_zh: parsed.welcome_title_zh || "",
            welcome_message_zh: parsed.welcome_message_zh || "",
            categories: parsed.categories || {},
        };
    } catch {
        return { ...DEFAULTS };
    }
}

export function saveZhSettings(settings) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {
        /* localStorage 불가(사생활 모드 등) 시 무시 */
    }
}
